module.exports = __webpack_public_path__ + "51a82d50a7e3633fe39cb927cfb37c80.svg";